import { createFileRoute } from "@tanstack/react-router";
import { assertPagePermission } from "@/features/auth/lib/assert-page-permission";
import { pageStateQueryOptions, PageAccessError } from "@/lib/queries";
import { WorkspacePage } from "@/features/workspace/pages/WorkspacePage";
import { PageError } from "@/features/auth/components/PageError";

export const Route = createFileRoute("/_authenticated/workspace")({
  beforeLoad: () => assertPagePermission("workspace"),
  loader: ({ context }) =>
    context.queryClient
      .ensureQueryData(pageStateQueryOptions("workspace"))
      .catch((err: unknown) => {
        if (err instanceof PageAccessError) return null;
        throw err;
      }),
  component: WorkspacePage,
  errorComponent: ({ error }) => (
    <PageError is403={error instanceof PageAccessError} />
  ),
});
